import { downloadBlob } from '@mint-lib/api-zod-support';
import { useQueryClient } from '@mint-lib/query-client';
import { Chat } from '@mint-sdk/api-ai-assistant';

import { useDeleteDocumentMutation } from '../../queries/rag.js';
import type { RagTableType } from '../../types/rag.js';

export const useDocumentActions = () => {
  const queryClient = useQueryClient();
  const { mutate: deleteDocumentM } = useDeleteDocumentMutation();

  const getDocumentBlob = async (fileId: string) => {
    const data = await Chat.getRagDocument({
      urlParams: { fileId },
    });
    return data;
  };

  const onDocumentDownload = async (document: RagTableType) => {
    const blob = await getDocumentBlob(document.fileId);
    downloadBlob(blob, document.fileName);
  };

  const onDocumentsBulkDownload = async (
    documents: RagTableType[],
    onDownload: () => void,
  ) => {
    if (!documents) return;
    for (const document of documents) {
      onDocumentDownload(document);
    }
    onDownload();
  };

  const onDocumentDelete = (document: RagTableType, onDelete: () => void) => {
    deleteDocumentM(document.fileId, {
      onSettled: async () => {
        onDelete();
        await queryClient.invalidateQueries({
          queryKey: Chat.listRagDocuments({}).queryKey,
        });
      },
    });
  };

  const onDocumentsBulkDelete = (
    documents: RagTableType[],
    onDelete: () => void,
  ) => {
    if (!documents) return;
    for (const document of documents) {
      onDocumentDelete(document, onDelete);
    }
  };

  return {
    onDocumentDownload,
    onDocumentsBulkDownload,
    onDocumentDelete,
    onDocumentsBulkDelete,
  };
};
